import { createAction } from '@reduxjs/toolkit'

// Глобальные события сессии: на них подписаны слайсы настроек и конфига,
// чтобы сбрасывать/обновлять состояние при логине и логауте.
export const actionUserLogin = createAction('user/login')
export const actionUserLogout = createAction('user/logout')
